import { Component, Input, HostBinding } from '@angular/core'
import { Colors } from '../../common/config/constants'

@Component({
  standalone: false,
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  @Input() color: string = Colors.colorAccent

  get secondColor() {
    return (
      '#' +
      this.color
        .replace(/^#/, '')
        .replace(/../g, (color) =>
          (
            '0' +
            Math.min(255, Math.max(0, parseInt(color, 16) + 10)).toString(16)
          ).substr(-2),
        )
    )
  }

  @Input() width: number

  @HostBinding('class.show')
  @Input()
  show = false
}
